import { withCompController } from '@wix/editor-elements-integrations/thunderbolt'
import type { FluidColumnsRepeaterCompProps, FluidColumnsRepeaterStateRefValues } from './types'

export const FluidColumnsRepeaterController = withCompController<
	FluidColumnsRepeaterCompProps,
	FluidColumnsRepeaterCompProps,
	FluidColumnsRepeaterCompProps,
	FluidColumnsRepeaterStateRefValues
>(({ mapperProps, stateValues }) => {
	return {
		...mapperProps,
		observeChildListChange: mapperProps.isMasterPage
			? stateValues.observeChildListChangeMaster
			: stateValues.observeChildListChange,
	}
})
